export const TEXT_POSITION_PRESETS = {
  top: 7,
  middle: 43,
  bottom: 82,
};

export const getTextPositionPreset = (positionY) => Object.entries(TEXT_POSITION_PRESETS).reduce(
  (closest, [name, value]) => (
    Math.abs(Number(positionY) - value) < Math.abs(Number(positionY) - TEXT_POSITION_PRESETS[closest])
      ? name
      : closest
  ),
  "top"
);
